import { Link } from 'react-router-dom'

const shell = {
  minHeight: '100vh',
  background: '#f7f8fb',
  color: '#15231d',
  padding: '48px 20px 80px',
  fontFamily: 'Inter, system-ui, sans-serif',
}

const card = {
  maxWidth: 920,
  margin: '0 auto',
  background: '#ffffff',
  border: '1px solid rgba(20,70,50,.12)',
  borderRadius: 24,
  padding: 'clamp(24px,4vw,48px)',
  boxShadow: '0 24px 70px rgba(20,70,50,.08)',
}

const link = { color: '#087a55', textDecoration: 'none', fontWeight: 700 }

function LegalShell({ eyebrow, title, children }) {
  return (
    <main style={shell}>
      <section style={card}>
        <Link to="/" style={link}>← Centro Médico Santa Clara</Link>
        <p style={{ marginTop: 32, fontSize: 12, fontWeight: 800, letterSpacing: '.16em', textTransform: 'uppercase', color: '#0b8b61' }}>{eyebrow}</p>
        <h1 style={{ fontSize: 'clamp(2rem,5vw,3.25rem)', margin: '8px 0 24px', lineHeight: 1.08 }}>{title}</h1>
        <div style={{ lineHeight: 1.75, color: '#40524a' }}>{children}</div>
        <nav style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginTop: 36, paddingTop: 24, borderTop: '1px solid rgba(20,70,50,.12)' }}>
          <Link to="/privacidad" style={link}>Privacidad</Link>
          <Link to="/terminos" style={link}>Términos</Link>
          <Link to="/agenda" style={link}>Agendar consulta</Link>
        </nav>
      </section>
    </main>
  )
}

export function SantaClaraPrivacy() {
  return (
    <LegalShell eyebrow="Privacidad" title="Política de Privacidad">
      <p>El Centro Médico Santa Clara utiliza los datos enviados por sus canales digitales para gestionar consultas, agendamiento, comunicación con pacientes, seguridad y las tareas operativas necesarias para prestar sus servicios.</p>
      <h2>Datos que pueden tratarse</h2>
      <p>Según el servicio solicitado, pueden procesarse datos de identificación y contacto, cédula, fecha de nacimiento, datos de aseguradora y la información mínima necesaria para coordinar una consulta. Los datos clínicos y la historia médica se rigen por controles y circuitos asistenciales separados de la web pública.</p>
      <h2>Finalidades</h2>
      <p>Los datos se utilizan para verificar identidad, reservar o administrar turnos, comunicarse con el paciente o responsable, prevenir abuso, mantener trazabilidad y cumplir obligaciones operativas o legales aplicables. La web pública no debe utilizar datos de salud para publicidad comportamental.</p>
      <h2>Menores de edad</h2>
      <p>Cuando el paciente sea menor de edad, el flujo digital puede requerir que un padre, madre, tutor o responsable autorizado confirme su vínculo y acepte el tratamiento de los datos necesarios para gestionar la atención.</p>
      <h2>Proveedores tecnológicos y enlaces externos</h2>
      <p>Santa Clara puede utilizar proveedores de infraestructura, mensajería, seguridad y soporte tecnológico estrictamente para operar el servicio. QorIAX presta soporte tecnológico a determinados flujos y aplica controles de separación por tenant, acceso y auditoría. Al abrir servicios externos —por ejemplo mapas o WhatsApp— el proveedor externo puede recibir datos técnicos de conexión, como la dirección IP, conforme a sus propias políticas.</p>
      <h2>Conservación y minimización</h2>
      <p>Los datos deben conservarse únicamente durante el período necesario para la finalidad correspondiente y las obligaciones aplicables. Los formularios públicos deben solicitar sólo la información necesaria para cada proceso.</p>
      <h2>Seguridad</h2>
      <p>Se aplican controles de autenticación, autorización, verificación de WhatsApp, protección anti-abuso y trazabilidad. Ningún sistema puede eliminar por completo el riesgo, por lo que los controles se revisan de manera periódica.</p>
      <h2>Derechos y consultas</h2>
      <p>Las solicitudes de acceso, corrección, actualización u otras consultas sobre datos personales pueden realizarse por los canales oficiales del Centro Médico Santa Clara. Cuando corresponda, podrá requerirse verificación de identidad antes de entregar o modificar información.</p>
      <p><strong>Última actualización:</strong> 28 de septiembre de 2026.</p>
    </LegalShell>
  )
}

export function SantaClaraTerms() {
  return (
    <LegalShell eyebrow="Condiciones" title="Términos de Uso">
      <p>Los servicios digitales del Centro Médico Santa Clara facilitan información institucional, consulta de profesionales, agendamiento y acceso a determinados servicios. La información pública no sustituye una evaluación médica profesional.</p>
      <h2>Agendamiento</h2>
      <p>Un turno se considera registrado únicamente cuando el sistema devuelve una confirmación exitosa. La disponibilidad puede modificarse por cambios operativos o reservas realizadas en simultáneo.</p>
      <h2>Identidad y consentimiento</h2>
      <p>El usuario debe proporcionar información veraz. El sistema puede verificar el número de WhatsApp y solicitar aceptación expresa de la Política de Privacidad y de estos Términos antes de finalizar una reserva.</p>
      <h2>Pacientes menores</h2>
      <p>Las reservas de menores deben ser gestionadas por un padre, madre, tutor o responsable autorizado. La confirmación digital del vínculo no sustituye la documentación o autorizaciones adicionales que puedan requerirse para determinados actos médicos.</p>
      <h2>Uso responsable</h2>
      <p>No está permitido intentar acceder a información de terceros, eludir controles de seguridad, automatizar solicitudes abusivas, falsear identidad ni utilizar los servicios para actividades ilícitas.</p>
      <h2>Urgencias</h2>
      <p>Los formularios, chat y canales digitales no sustituyen los mecanismos de atención de urgencias. Ante una situación urgente, la persona debe utilizar los canales asistenciales correspondientes.</p>
      <h2>Actualizaciones</h2>
      <p>Estas condiciones pueden actualizarse cuando cambien los servicios, requisitos de seguridad o normativa aplicable. La versión vigente se publica en esta página.</p>
      <p><strong>Última actualización:</strong> 28 de septiembre de 2026.</p>
    </LegalShell>
  )
}

const qoriaxShell = {
  ...shell,
  background: '#090b10',
  color: '#f5f7fb',
}

const qoriaxCard = {
  ...card,
  background: 'rgba(255,255,255,.055)',
  border: '1px solid rgba(255,255,255,.12)',
  boxShadow: '0 24px 70px rgba(0,0,0,.28)',
}

const qoriaxLink = { color: '#c88952', textDecoration: 'none', fontWeight: 700 }

function QoriaxLegalShell({ eyebrow, title, children }) {
  return (
    <main style={qoriaxShell}>
      <section style={qoriaxCard}>
        <Link to="/" style={qoriaxLink}>← QorIAX</Link>
        <p style={{ marginTop: 32, fontSize: 12, fontWeight: 800, letterSpacing: '.16em', textTransform: 'uppercase', color: '#c88952' }}>{eyebrow}</p>
        <h1 style={{ fontSize: 'clamp(2rem,5vw,3.25rem)', margin: '8px 0 24px', lineHeight: 1.08 }}>{title}</h1>
        <div style={{ lineHeight: 1.75, color: '#b8c0cc' }}>{children}</div>
        <nav style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginTop: 36, paddingTop: 24, borderTop: '1px solid rgba(255,255,255,.12)' }}>
          <Link to="/privacidad" style={qoriaxLink}>Privacidad</Link>
          <Link to="/terminos" style={qoriaxLink}>Términos</Link>
          <Link to="/saas" style={qoriaxLink}>Acceso SaaS</Link>
        </nav>
      </section>
    </main>
  )
}

export function QoriaxPrivacy() {
  return (
    <QoriaxLegalShell eyebrow="Privacidad" title="Política de Privacidad">
      <p>QorIAX procesa los datos necesarios para operar sus servicios digitales, autenticar usuarios, mantener seguridad, trazabilidad y prestar las funciones contratadas por cada organización.</p>
      <h2>Aislamiento por tenant</h2>
      <p>Cada organización opera como un tenant independiente. Los datos, sesiones, configuración, integraciones y permisos de un tenant no deben mezclarse ni utilizarse para resolver solicitudes de otro tenant.</p>
      <h2>Categorías de datos</h2>
      <p>Según el módulo, pueden tratarse datos de cuenta, contacto, operación, facturación, auditoría y, cuando el cliente habilita módulos regulados, información clínica, financiera o legal. Cada módulo debe aplicar minimización y controles acordes a su sensibilidad.</p>
      <h2>Finalidades y roles</h2>
      <p>QorIAX utiliza los datos para prestar la plataforma, aplicar controles de seguridad, soporte, facturación, auditoría y mejora operativa. El rol jurídico de QorIAX y de cada organización respecto de los datos depende del servicio y del contrato aplicable.</p>
      <h2>Proveedores e integraciones</h2>
      <p>La plataforma puede utilizar proveedores de infraestructura, comunicaciones, pagos u otras integraciones autorizadas por el tenant. Las integraciones deben limitarse al alcance necesario y respetar la separación entre organizaciones.</p>
      <h2>Datos sensibles e inteligencia artificial</h2>
      <p>Los módulos que puedan tratar información sensible aplican controles de acceso, minimización y auditoría. QorIAX no debe incorporar datos sensibles a analítica publicitaria ni exponerlos entre tenants. Las funciones de inteligencia artificial están sujetas a controles de contexto y autorización.</p>
      <h2>Conservación y seguridad</h2>
      <p>La conservación depende de la finalidad, contrato y obligaciones aplicables. La plataforma utiliza autenticación, autorización, registros de eventos y separación lógica; los controles se revisan de manera continua.</p>
      <h2>Consultas y derechos</h2>
      <p>Las solicitudes relacionadas con datos personales deben dirigirse a la organización responsable o a los canales contractuales correspondientes de QorIAX, según el servicio involucrado.</p>
      <p><strong>Última actualización:</strong> 28 de septiembre de 2026.</p>
    </QoriaxLegalShell>
  )
}

export function QoriaxTerms() {
  return (
    <QoriaxLegalShell eyebrow="Condiciones" title="Términos de Uso">
      <p>QorIAX es una plataforma tecnológica multi-tenant. El acceso a módulos privados requiere autorización válida de la organización correspondiente.</p>
      <h2>Uso autorizado</h2>
      <p>No está permitido intentar acceder a otro tenant, eludir controles de seguridad, extraer datos sin autorización, utilizar credenciales ajenas ni automatizar acciones abusivas.</p>
      <h2>Responsabilidad operativa</h2>
      <p>Las funciones de apoyo, automatización e inteligencia artificial no sustituyen las decisiones profesionales, clínicas, legales, financieras o administrativas que correspondan a cada organización y sus responsables.</p>
      <h2>Suscripciones y facturación</h2>
      <p>Cuando un plan sea recurrente, la interfaz de contratación debe informar antes del pago el precio, moneda, ciclo de facturación, condición de renovación, mecanismo de cancelación y cualquier condición comercial relevante. Las condiciones específicas mostradas en el checkout y el contrato aplicable forman parte del acuerdo de suscripción.</p>
      <h2>Cancelación</h2>
      <p>Los mecanismos de cancelación disponibles dependen del plan y del canal de contratación. La plataforma debe informar el efecto de la cancelación y la fecha hasta la cual continúa el acceso cuando corresponda.</p>
      <h2>Disponibilidad y cambios</h2>
      <p>Los módulos pueden evolucionar conforme a nuevas versiones, controles de seguridad y requisitos contractuales, manteniendo la separación entre tenants como requisito estructural.</p>
      <p><strong>Última actualización:</strong> 28 de septiembre de 2026.</p>
    </QoriaxLegalShell>
  )
}

export function PublicNotFound() {
  const host = typeof window !== 'undefined' ? window.location.hostname.replace(/^www\./, '').toLowerCase() : ''
  const qoriax = host === 'qoriax.com' || host === 'coriex.com' || host.startsWith('saas.qoriax')
  const accent = qoriax ? '#b87333' : '#0b8b61'
  return (
    <main style={{ ...shell, background: qoriax ? '#090b10' : shell.background, color: qoriax ? '#f5f7fb' : shell.color }}>
      <section style={{ ...card, textAlign: 'center', maxWidth: 680, background: qoriax ? 'rgba(255,255,255,.055)' : card.background, borderColor: qoriax ? 'rgba(255,255,255,.12)' : 'rgba(20,70,50,.12)' }}>
        <p style={{ fontWeight: 800, letterSpacing: '.16em', color: accent }}>404</p>
        <h1>Página no encontrada</h1>
        <p style={{ color: qoriax ? '#b8c0cc' : '#52655d' }}>La dirección solicitada no corresponde a una página pública disponible.</p>
        <p><Link to="/" style={{ ...link, color: accent }}>Volver al inicio →</Link></p>
      </section>
    </main>
  )
}
